export default "__VITE_ASSET__CnaCtmDW__"